import { Navigate } from "react-router-dom";

import { getSettingsDefaultRoute } from "@/config/routes";
import { useRoles } from "@/hooks/useRoles";

/**
 * Redirects users to the appropriate settings page based on their role
 * - org:admin -> /settings/organization
 * - ws:admin -> /settings/workspace
 * - ws:member -> /settings/snippets
 */
export const SettingsRedirect = () => {
  const { orgRole, workspaceRole } = useRoles();
  const defaultRoute = getSettingsDefaultRoute(orgRole, workspaceRole);

  return <Navigate replace to={defaultRoute} />;
};
